import { render } from "./MyHeader.vue?vue&type=template&id=6e12ab7a&scoped=true&ts=true&lang=pug"
import script from "./MyHeader.vue?vue&type=script&lang=ts&setup=true"
export * from "./MyHeader.vue?vue&type=script&lang=ts&setup=true"

import "./MyHeader.vue?vue&type=style&index=0&id=6e12ab7a&scoped=true&lang=less"

import exportComponent from "/Users/yangkeneng/Projects/mddh5-master/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e12ab7a"]])

export default __exports__